import { render, staticRenderFns } from "./enrolRecord.vue?vue&type=template&id=8a78e288&scoped=true&"
import script from "./enrolRecord.vue?vue&type=script&lang=js&"
export * from "./enrolRecord.vue?vue&type=script&lang=js&"
import style0 from "./enrolRecord.vue?vue&type=style&index=0&id=8a78e288&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a78e288",
  null
  
)

export default component.exports